import React from 'react';
import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import UserImg from 'img/user-green-report.svg';

import './styles.scss';
import { ReportItem } from './interface';
import { ActionButton } from 'components/ModelButton';

export const ReportDashItem: React.FC<ReportItem> = (props) => {
	const { description, trackItem, trackName, action } = props;

	return (
		<Row className="flex-1 bg-white mx-1 mt-3 py-4 justify-center border-radius-report">
			<Row className="bg-green p-4 justify-between flex-column">
				<Text>{description}</Text>
				<ActionButton
					trackName={trackName}
					trackItem={trackItem}
					textButton="Exportar Dados"
					action={action}
				/>

				<Row className="bg-white ps-absolute">
					<img title='user-img' src={UserImg} />
				</Row>
			</Row>
		</Row>
	);
};